module.exports = __webpack_public_path__ + "img/icon_bag-grey.94c021e5.png";